// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL || '',
  SUPABASE_PUBLISHABLE_KEY || '',
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true, // Detectar sessão em URLs de redirect
      storageKey: 'vyra-auth-token', // Chave customizada para PWA
      flowType: 'pkce', // Mais seguro para PWAs
    },
    global: {
      headers: {
        'X-Client-Info': 'vyra-pwa', // Identificar requisições do PWA
      },
    },
  }
);